import { textColors } from 'ui/theme';

export const iconColor = (isSelected: boolean, disabled?: boolean) => {
  if (disabled) return textColors.textDisabled;
  return isSelected ? textColors.textPrimary : textColors.textSecondary;
};
